import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ShieldCheckIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const CTA_LINK = 'https://mareaa.online/checkout/v3/start/1972060668/25acb4abfe837a80a6772bcc7e308b2d3875c2d2?from_store=1&country=AR';
export function HeroSection() {
  return <section className="relative w-full bg-gradient-to-b from-bg-mint via-bg-softer to-white pt-20 pb-12 px-4 md:px-8" data-id="element-103">
      <div className="max-w-6xl mx-auto pt-6" data-id="element-104">
        <div className="grid md:grid-cols-2 gap-10 lg:gap-14 items-center" data-id="element-105">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7
        }} className="space-y-5" data-id="element-106">
            <h1 className="text-3xl md:text-4xl lg:text-[2.75rem] font-serif leading-tight text-text-dark" data-id="element-107">
              Si comés sano pero tu abdomen sigue{' '}
              <span className="text-highlight" data-id="element-108">hinchado</span>… esto es lo que
              nadie te está explicando
            </h1>

            <p className="text-base md:text-lg text-primary-mid leading-relaxed" data-id="element-109">
              Miles de mujeres hacen todo "bien"… y aun así se levantan con el
              vientre inflado, la ropa apretada y sin entender por qué.
            </p>

            <div className="space-y-1 text-primary-mid/80 text-sm" data-id="element-110">
              <p data-id="element-111">Te mirás al espejo y no te sentís cómoda.</p>
              <p data-id="element-112">La ropa aprieta. Te sentís pesada. Frustrada.</p>
            </div>

            <div className="bg-white/80 border border-secondary-light/30 rounded-xl p-4 space-y-1.5" data-id="element-113">
              <p className="text-primary-mid font-medium text-sm" data-id="element-114">
                No es falta de voluntad. No es que comés mal.
              </p>
              <p className="text-accent font-semibold text-sm" data-id="element-115">
                👉 Es que nadie te enseñó a atacar la inflamación desde la raíz.
              </p>
            </div>

            <div className="space-y-2 text-sm text-primary-mid" data-id="element-116">
              <p className="flex items-start gap-2" data-id="element-117">
                <span className="text-accent mt-0.5" data-id="element-118">✓</span> Te levantás
                sintiéndote liviana… y a las horas tu abdomen se hincha solo
              </p>
              <p className="flex items-start gap-2" data-id="element-119">
                <span className="text-accent mt-0.5" data-id="element-120">✓</span> Comés sano, tomás
                agua, evitás harinas… y nada cambia
              </p>
              <p className="flex items-start gap-2" data-id="element-121">
                <span className="text-accent mt-0.5" data-id="element-122">✓</span> Sentís que tu
                cuerpo ya no responde como antes
              </p>
            </div>

            {/* Price */}
            <div className="bg-white border border-secondary-light/30 rounded-2xl p-5 shadow-sm" data-id="element-123">
              <p className="text-sm text-primary-mid/50 line-through" data-id="element-124">
                $29.999 ARS
              </p>
              <div className="flex items-center gap-3 mt-1" data-id="element-125">
                <span className="text-3xl md:text-4xl font-bold text-text-dark font-serif" data-id="element-126">
                  $9.999 ARS
                </span>
                <span className="bg-highlight text-white text-xs font-bold px-3 py-1.5 rounded-full" data-id="element-127">
                  🔥 77% OFF
                </span>
              </div>
              <div className="mt-3 space-y-1 text-xs text-primary-mid/60" data-id="element-128">
                <p data-id="element-129">✔ Ebook + Bonos incluidos</p>
                <p data-id="element-130">✔ Acceso inmediato</p>
                <p data-id="element-131">✔ 100% digital (descarga directa)</p>
              </div>
              <p className="text-xs text-highlight font-semibold mt-2" data-id="element-132">
                ⚠️ Precio especial por tiempo limitado
              </p>
            </div>

            {/* CTA */}
            <motion.a href={CTA_LINK} onClick={trackAddToCart} whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} className="flex items-center justify-center gap-3 w-full bg-accent hover:bg-accent/90 text-white font-bold px-8 py-5 rounded-full shadow-lg shadow-accent/25 transition-all duration-300 text-base md:text-lg" data-id="element-133">
              SÍ, QUIERO DESINFLAMAR MI ABDOMEN DESDE HOY
              <ArrowRightIcon className="w-5 h-5 flex-shrink-0" data-id="element-134" />
            </motion.a>

            <div className="flex flex-wrap gap-x-3 gap-y-1 justify-center text-xs text-primary-mid/50" data-id="element-135">
              <span data-id="element-136">✓ Acceso inmediato</span>
              <span data-id="element-137">·</span>
              <span data-id="element-138">✓ Guía paso a paso</span>
              <span data-id="element-139">·</span>
              <span data-id="element-140">✓ Sin dietas extremas</span>
            </div>
          </motion.div>

          {/* Product image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.15
        }} className="relative" data-id="element-141">
            <div className="relative transform rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-142">
              <div className="absolute -inset-4 bg-gradient-to-br from-secondary/25 to-accent/15 rounded-3xl blur-2xl" data-id="element-143"></div>
              <img src="https://cdn.magicpatterns.com/uploads/1v6cMX27m6RnLsSCgzR5XC/White_and_Orange_Healthy_Food_Instagram_Post.png" alt="Cero Inflamación Ebook" className="relative w-full max-w-sm mx-auto rounded-2xl shadow-2xl" data-id="element-144" />
            </div>

            {/* Trust badges below image */}
            <div className="flex flex-wrap gap-2 justify-center mt-6" data-id="element-145">
              <div className="flex items-center gap-1.5 bg-white border border-secondary-light/30 px-3 py-2 rounded-lg text-xs text-primary-mid shadow-sm" data-id="element-146">
                <ShieldCheckIcon className="w-3.5 h-3.5 text-accent" data-id="element-147" />
                Compra segura
              </div>
              <div className="flex items-center gap-1.5 bg-white border border-secondary-light/30 px-3 py-2 rounded-lg text-xs text-primary-mid shadow-sm" data-id="element-148">
                <CreditCardIcon className="w-3.5 h-3.5 text-accent" data-id="element-149" />
                Pago protegido
              </div>
              <div className="flex items-center gap-1.5 bg-white border border-secondary-light/30 px-3 py-2 rounded-lg text-xs text-primary-mid shadow-sm" data-id="element-150">
                <ZapIcon className="w-3.5 h-3.5 text-accent" data-id="element-151" />
                Acceso inmediato
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}